import ViewBase from '../../../view-base.view';
import trainModel from "../../../../models/custom-vision/custom-vision.trains.model";
import languageModel from '../../../../models/language.model';
import { Dialog } from 'construct-ui';
import paginationComponent from '../../../../components/pagination/pagination.component';
import CVIterationImagesListView from '../cvtrains/custom-vision-iteration-images-list.view';

export default function CVIterationsListView() {
    ViewBase.call(this);

    let inputDataModel = { totalCount: 0, pageIndex: 1, pageSize: 10 };

    let listOfIterations = [];

    let isPopupIterationImagesListOpened = false;

    let selectedProjectId = 0;
    let selectedIterationId = 0;

    let _loadIterations = () => {
        this.showLoading();

        trainModel.getIterationsList(
            _iterationsListSuccessCallBack,
            _iterationsListErrorCallBack,
            selectedProjectId,
            inputDataModel.pageIndex, inputDataModel.pageSize
        );
    }

    let _iterationsListSuccessCallBack = (result) => {
        this.hideLoading();
        
        listOfIterations = result.data;
        if (listOfIterations == null) {
            listOfIterations = [];
        }
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
    }

    let _iterationsListErrorCallBack = (error) => {
        this.hideLoading();

        listOfIterations = [];

        this.handleError(error);
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _loadTags();
    }

    let onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _loadTags();
    }

    let _showSubmitTrainingRequestConfirmation = () => {
        this.showConfirm(this.getText("LT00000380", "Are you sure you want to request to train this project?"), this.getText("LT00000382", "Submit Training Request"), (e) => {

            if (e == "YES") {
                trainModel.submitTrainingRequest(
                    (result) => {
                        this.showMessage(this.getText("LT00000381", "The training request has been submitted."), this.getText("LT00000382", "Submit Training Request"));

                        _loadIterations();
                    }, (error) => {
                        if (error.code == 404) {
                            inputDataModel = { totalCount: 0, pageIndex: 1, pageSize: 10 };
                        }

                        this.handleError(error);
                    },
                    selectedProjectId);
            }
        });

    }

    let _showIterationImagesList = (iterationId) => {
        selectedIterationId = iterationId;
        isPopupIterationImagesListOpened = true;
    }

    let _showPublishIterationConfirmation = (iterationId) => {
        this.showConfirm(this.getText("LT00000383", "Are you sure you want to publish this version?"), this.getText("LT00000385", "Enable Version"), (e) => {

            if (e == "YES") {
                trainModel.publishIteration(
                    () => {
                        this.showMessage(this.getText("LT00000384", "The version has been published."), this.getText("LT00000385", "Enable Version"));

                        _loadIterations();
                    }, (error) => {
                        if (error.code == 404) {
                            inputDataModel = { totalCount: 0, pageIndex: 1, pageSize: 10 };
                        }
                        
                        this.handleError(error);
                    },
                    selectedProjectId,
                    iterationId);
            }
        });

    }

    let _showUnpublishIterationConfirmation = (iterationId) => {
        this.showConfirm(this.getText("LT00000386", "Are you sure you want to deactivate this version?"), this.getText("LT00000388", "Deactivate Version"), (e) => {

            if (e == "YES") {
                trainModel.unpublishIteration(
                    () => {
                        this.showMessage(this.getText("LT00000387", "The version has been deactivated."), this.getText("LT00000388", "Deactivate Version"));

                        _loadIterations();
                    }, (error) => {
                        if (error.code == 404) {
                            inputDataModel = { totalCount: 0, pageIndex: 1, pageSize: 10 };
                        }
                        
                        this.handleError(error);
                    },
                    selectedProjectId,
                    iterationId);
            }
        });

    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.projectId) {
                selectedProjectId = vnode.attrs.projectId;

                _loadIterations();
            }
        },
        view: (vnode) => {
            let numberOfIterations = listOfIterations.length;

            return [
                m('.row',
                    m('.col-md-12',
                        m('.card',
                            m('.card-body',
                                m('.d-flex.justify-content-end mb-2',
                                    m('button.btn.btn-outline-primary[type="button"]',  
                                        { onclick: _showSubmitTrainingRequestConfirmation }, [
                                            m("i.bi.bi-plus-lg.me-0")
                                        ]                                                            
                                    )
                                ),
                                m(".table-responsive",
                                    m("table.table table-striped",
                                        [
                                            m("thead",
                                                m("tr.align-middle",
                                                    [
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000389", "Version")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000015", "Status")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000041", "Create Date")),
                                                        m("th", { "scope": "col", "colspan": "2" }, "")
                                                    ])
                                            ),
                                            m("tbody",
                                                listOfIterations.length == 0 &&
                                                m("tr", { "class": "align-middle" },
                                                    m("td", { "colspan": "5" }, languageModel.getText("EM00000141", "No records found."))
                                                ),
                                                listOfIterations.map((iteration, index) =>
                                                    [
                                                        m("tr",
                                                            [
                                                                iteration.azureTrainingStatus.trim() == 'Completed' && iteration.publishedModelName.trim() != '' && m("td", m("i.bi.bi-check-circle-fill.text-success"), "Version " + (numberOfIterations - index)),
                                                                (iteration.azureTrainingStatus.trim() != 'Completed' || iteration.publishedModelName.trim() == '') && m("td", "Version " + (numberOfIterations - index)),
                                                                m("td", iteration.azureTrainingStatus),
                                                                m("td", iteration.createDateDisplay),
                                                                iteration.azureTrainingStatus.trim() == 'Completed' && m("td", m("a", { "href": "javascript:;", onclick: () => { _showIterationImagesList(iteration.id) } }, m("span", languageModel.getText("LT00000390", "View Setup")))),
                                                                iteration.azureTrainingStatus.trim() == 'Completed' && iteration.publishedModelName.trim() == '' && m("td", m("a", { "href": "javascript:;", onclick: () => { _showPublishIterationConfirmation(iteration.id) } }, m("span", languageModel.getText("LT00000166", "Activate")))),
                                                                iteration.azureTrainingStatus.trim() == 'Completed' && iteration.publishedModelName.trim() != '' && m("td", m("a.text-danger", { "href": "javascript:;", onclick: () => { _showUnpublishIterationConfirmation(iteration.id) } }, m("span", languageModel.getText("LT00000165", "Deactivate")))),
                                                                iteration.azureTrainingStatus.trim() != 'Completed' && m("td", { "scope": "col", "colspan": "2" }, "")
                                                            ])
                                                    ]),
                                            )
                                        ]
                                    )
                                ),
                                m(paginationComponent,
                                    {
                                        currentPage: inputDataModel.pageIndex,
                                        pageSize: inputDataModel.pageSize,
                                        totalItems: inputDataModel.totalCount,
                                        onPageChanged: onPageChanged,
                                        onPageSizeChanged: onPageSizeChanged
                                    }
                                )
                            )
                        )
                    ),
                    m(Dialog, {
                        isOpen: isPopupIterationImagesListOpened,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { isPopupIterationImagesListOpened = false; },
                        title: this.getText("LT00000391", "Training Images of the Version"),
                        content: m(CVIterationImagesListView, { 
                            onPopupClose: ()=>{ isPopupIterationImagesListOpened = false },
                            projectId: selectedProjectId,
                            iterationId: selectedIterationId
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                ),
                this.getBaseViews()
            ]
        }
    }
}
